import Component from '../abstracts/Component';

export default class QuickBuyComponent extends Component {

  constructor() {
    super();
  }

  get SELECTORS() {
    return {
      card: '.product-card:not(.is-focus)',
      main: '.product-card:not(.is-focus) .js-quick-buy',
      arrows: '.image-wrapper .slick-arrow',
      carousel: '.js-lazy-productbox-carousel'
    };
  }

  get SLICKCONFIG() {
    return {
      infinite: true,
      arrows: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1
    };
  }

  get CLASSES() {
    return {
      carouselLoaded: 'carousel-loaded'
    };
  }

  composeSlideTemplate(imgUrl) {
    // aggiunta del tag picture
    // se l'imgUrl è jpg -> viene fatto il replace di jpg con webp ed aggiunto il tag source
    let t = `<picture>`;
    if (imgUrl.indexOf(".jpg") > 0) {
      let webpUrl = imgUrl.replace(".jpg", ".webp");
      t = t + `<source type="image/webp" srcset="${webpUrl}" />`;
    }
    t = t + `<img src="${imgUrl}" class="media item" alt="">`;
    t = t + `</picture>`;
    return t;
  }

  bindEvents() {
    let card = document.querySelectorAll(this.SELECTORS.card);

    if (this.$matchMedia(null, 'lg')) {
      card.forEach(el => {
        const ctx = this;
        el.addEventListener("mouseenter", function (e) {
          const imgUrlArr = this.dataset.carouselGallery.split('|');
          const myCarousel = this.querySelectorAll(ctx.SELECTORS.carousel);
          const l = imgUrlArr.length;
          let c = 0;

          function onInitLazyCarousel() {
            if (l === c && myCarousel.length) {
              if (ctx.$matchMedia(null, 'lg')) {
                $(myCarousel).slick(ctx.SLICKCONFIG);
              }
              myCarousel[0].closest(ctx.SELECTORS.main).classList.add(ctx.CLASSES.carouselLoaded);
            }
          };

          if (l) {
            imgUrlArr.forEach(imgUrl => {
              if (!$(myCarousel).closest(ctx.SELECTORS.main).hasClass(ctx.CLASSES.carouselLoaded) && ctx.$matchMedia(null, 'lg')) {
                $(myCarousel).append(ctx.composeSlideTemplate(imgUrl))
                c = c + 1;
                onInitLazyCarousel();
              }
            });
          }
        });
      })
    }

    this.$on('click.arrows', ({
      event
    }) => {
      event.preventDefault();
    }, 'body', this.SELECTORS.arrows)

    $('.js-custom-arrow').on('click', function (e) {
      e.preventDefault();
    })
  }

  destroyCarousels() {
    const main = document.querySelectorAll(this.SELECTORS.carousel);
    main.forEach(el => {
      const hasCarousel = $(el);
      if (hasCarousel.hasClass('slick-initialized')) {
        this.log('eseguo l\'unslick');
        hasCarousel.slick(
          'unslick'
        );
        hasCarousel.closest('a').removeClass(this.CLASSES.carouselLoaded);
        hasCarousel.children().remove();
      }
    })
  }


  render() {
    if (document.querySelector(this.SELECTORS.main)) {
      this.bindEvents();
    }

    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.updated, ({
      e,
      payload
    }) => {
      this.bindEvents(e);
    });

    this.$on('resize.quickbuy', () => {
      this.destroyCarousels();

    })

  }
}
